import React, { useCallback, useEffect, useMemo } from 'react'
import GenSdkButton from './GenSdkButton';
import TokenBox from '../../../widgets/TokenBox';
import CopyToClip from '../../../../infra/CopyToClip';
import { getEnvBasePath, getSelectedEnvName, getSelectedEnvPath, sdkParam } from '../../../../hooks/useSelector';
import useConfigsNavigator from '../../../../hooks/useConfigsNavigator';
import { useTokensContext } from '../../../../providers/TokensContextProvider';
import { useConfigStepsContext } from '../../../../providers/ConfigStepsContextProvider';
import { K_INFO } from '../../../../providers/ConfigsDataContextProvider';
import { useOperatorContext } from '../../../login/OperatorContextProvider';
import { useFolderListenerContext } from '../../../../providers/FolderListenerContextProvider';
import './SdkInfoArea.css';
import './SdkBox.css';

/*
	┌───────────────────────────────────────┐
	│ sdkGeneratedData   					 			    │
	└───────────────────────────────────────┘			
     basePath;
     selectedTeamId; // Not in use by the Client Web for now.
     sdkIdToken;
     sdkAccessToken;
*/  
export default function SdkBox() {
  const {operator}                      = useOperatorContext();
  const {idToken}                       = useTokensContext();  
  const {configSteps}                   = useConfigStepsContext();
  const {getConfigNodeByPath}           = useConfigsNavigator();  
  const {folderChanged}                 = useFolderListenerContext();

  useEffect(()=>{    
  },[folderChanged]);

  const sdkBasePath = getEnvBasePath(configSteps);
  const sdkPath = sdkBasePath+'.'+K_INFO+'.sdk'; // TODO: `${sdkBasePath}.${K_INFO}.sdk`;
  const sdkNode = getConfigNodeByPath(sdkPath); // jp.query(configsData, sdkPath)[0];
  const hasSdkFn    = useCallback(() => Boolean(sdkNode?.sdkIdToken), [sdkNode?.sdkIdToken]);
  const hasSdk      = useMemo(()=>hasSdkFn(), [hasSdkFn]);
  const noSdkFn     = useCallback(() => !hasSdk, [hasSdk]);
  const noSdk       = useMemo(() => noSdkFn(), [noSdkFn]);

  const envPath = getSelectedEnvPath(configSteps);
  const envName = getSelectedEnvName(configSteps);
  const jvmArg = `-Dkiponos="${sdkParam(configSteps)}"`; 
  const genBtn = <GenSdkButton userIdToken={idToken} selectedTeamId={operator.selectedTeamId} envPath={envPath} envName={envName} isNew={noSdk} />;

  return (
    <div className='sdkFooter'>
      <div className='sdkInfoArea'>
        <div className='sdkTitle'>
          {hasSdk && <div>Your {envName} SDK:</div>}
          {hasSdk && <div><a href='https://central.sonatype.com/artifact/io.kiponos/sdk-boot-3' target='_blank' rel='noopener noreferrer'>View on Maven Central</a></div>}                                     
          {noSdk && <div> {envName} has no SDK tokens</div>}
        </div>

        {hasSdk && 
        <div className='sdkBody'>
          <div className='sdkTable'>
            <div className='sdkHeader'> {envName} Environment Variables </div>
            <div className='sdkRow'> 
              <TokenBox envVar='KIPONOS_ID' token={sdkNode.sdkIdToken}/>
              <TokenBox envVar='KIPONOS_ACCESS' token={sdkNode.sdkAccessToken}/>
            </div>
            <div className='sdkHeader'> Java System Property </div>
            <div className='sdkRow'>
              <div style={{display:'flex'}}>
                <div className='codeTerminal'> {jvmArg} </div>
                <CopyToClip text={jvmArg} />            
              </div>
            </div>
            <div className='sdkHeader'>Tokens</div>
            <div className='sdkRow'> {genBtn} </div>
          </div>
        </div>}
        {
          noSdk &&  <div className='sdkHeader'>                                  
                        <div style={{paddingBottom: 16}}>
                          {genBtn}
                        </div>
                      </div>
        }
      </div>
    </div>
)}
